module.exports = __webpack_public_path__ + "media/images/txt_kv-67512e90246ed7c045c9f0e19c00c3e2.svg";